import { css } from 'styled-components'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

/**
 * Contentful pages only. The CMS colour dropdown is fixed at white/grey/dark, so rebrand
 * teal reuses the `dark` slot rather than adding a fourth Contentful option that every
 * existing entry would have to be re-authored to pick up. Rebrand-gated, so legacy dark
 * blocks keep their near-black surface and no global palette token moves.
 *
 * Text keeps paletteType=inverse, which already supplies the white contrast teal needs.
 * `path-scoped-beige-dark` retains its beige remap (see contentfulRebrandBeigeVideoBlock);
 * excluding it here makes the two treatments mutually exclusive regardless of rule order.
 * Prefer &&.class over nested && under body… (nested && emits a broken selector).
 */
export const rebrandTealDarkBackground = css`
  body.${REBRAND_PALETTE_CLASS} &&.background-color-dark:not(.path-scoped-beige-dark) {
    background-color: var(--palette-highlight-primary-dark-background);
  }
`
